export const AGE_BANDS = ['3-5', '6-8', '9-12'] as const
export const MAX_CHILDREN = 10

export const STAGES = [
  {
    ages: 'Ages 3-5 - Balloon',
    title: 'Keep it up',
    blurb: 'Almost none of this looks like volleyball to a parent watching. All of it is volleyball.',
    skills: [
      'Tracking a moving object with the eyes',
      'Getting under the ball before it arrives',
      'Two hands, above the forehead, every time',
      'Waiting for a turn without losing interest',
    ],
  },
  {
    ages: 'Ages 6-8 - Beach ball',
    title: 'Make it go where you want',
    blurb: 'The ball gets faster and heavier. Aim starts to matter, and so does the person next to you.',
    skills: [
      'Forearm passing platform - flat, no swing',
      'Underhand serve over a lowered net',
      'Calling the ball out loud before you play it',
      'Moving to a spot instead of reaching for it',
    ],
  },
  {
    ages: 'Ages 9-12 - Volleyball',
    title: 'Play the actual game',
    blurb: 'A lighter ball and a lower net, but a real rally: three contacts, a real serve, a real score.',
    skills: [
      'Bump, set, hit as a connected sequence',
      'Overhand serve with a consistent toss',
      'Rotation, court coverage, reading the other side',
      'Losing a point and playing the next one anyway',
    ],
  },
]
